import { render } from "./ViewReportsView.vue?vue&type=template&id=3901c4bd&scoped=true&ts=true"
import script from "./ViewReportsView.vue?vue&type=script&lang=ts"
export * from "./ViewReportsView.vue?vue&type=script&lang=ts"

import "./ViewReportsView.vue?vue&type=style&index=0&id=3901c4bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3901c4bd"]])

export default __exports__